
import { mapGetters, mapActions } from 'vuex';
import formItem from '@/component/form-item.vue';
import Datetime from 'vux/src/components/datetime/index.vue'

import pageHead from '@/component/page-header.vue';
export default {
components: {
formItem,
Datetime,
pageHead
},
name: 'InitiateRights',
data() {
return {
value2: '',
visibility: false,
mapValue: '',
mapObj: '',
geolocation: '',
loctionName: '',
textNull: ''
};
},
methods: {
...mapActions([]),
getDate() {
this.visibility = true;
}
},
watch: {},
computed: {
...mapGetters([])
},
created() {},
mounted() {
let elem = document.querySelector('#vux_view_box_body');
setTimeout(() => {
elem.style.paddingBottom = '0';
}, 10);
let self = this;
self.mapObj = new AMap.Map('iCenter');
self.mapObj.plugin('AMap.Geolocation', function() {
self.geolocation = new AMap.Geolocation({
enableHighAccuracy: true,
timeout: 3000,
maximumAge: 0,
convert: true,
showButton: true,
buttonPosition: 'RB',
buttonOffset: new AMap.Pixel(10, 20),
showMarker: true,
showCircle: true,
panToLocation: true,
zoomToAccuracy: true,
useNative: true
});
self.mapObj.addControl(self.geolocation);
self.geolocation.getCurrentPosition();
AMap.event.addListener(self.geolocation, 'complete', onComplete);
AMap.event.addListener(self.geolocation, 'error', onError);

});
function onError(data) {

console.log(data);
}

function onComplete(data) {
console.log(data);
self.loctionName = data.formattedAddress;
}
}
};
